/* The board's view as its address names it: a module of its own, since the route reads it
 * while deciding the address, before the board's code (and its client) has loaded. */

/** The board's two views, kept in the address (`?view=`): its columns and a table. The team
 *  drawn as an org chart is Team's. */
export type BoardView = "columns" | "table";

export function boardView(value: unknown): BoardView | undefined {
  return value === "table" ? value : undefined;
}
